'use strict';

import VZModal from 'Components/modals/VZModal';
import { getJourney, updateJourney } from './journeyHelper';

export default class VZJourneyModal extends VZModal {
    constructor() {
        super();
    }

    static get observedAttributes() {
        return ['products', 'class'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'products') {
            const value = newValue.split('|');
            this.toggleProductVisibility(value);
        }

        if (name === 'class' && newValue.includes('show')) this.updateModal();
    }

    connectedCallback() {
        this.setInitialState();
    }

    setInitialState() {
        this.setAttribute('products', getJourney().join('|'));
    }

    updateModal() {
        const checkboxes = [...document.querySelectorAll('vz-journey input:checked')];
        const productIDS = checkboxes
            .map((item) => item.id)
            .concat(document.querySelector('[data-configurator-type]')?.dataset?.configuratorType)
            .concat(JSON.parse(this.getAttribute('products-in-cart')))
            .filter((item) => item && !item.includes('_dummy'));
        this.updateResources();

        if (checkboxes.length > 0 && !productIDS.every((id) => id === 'one-net')) {
            const updateUrls = {
                'business-mobile': this.querySelector('li[data-id=business-mobile]')?.getAttribute('data-url'),
                internet: this.querySelector('li[data-id=internet]')?.getAttribute('data-url')
            };
            updateJourney(productIDS, updateUrls);
            this.setAttribute('products', productIDS.join('|'));
        }
    }

    getNextProduct() {
        const nextProduct = this.querySelector('[data-id]:not(.d-none):not(.order-0)');
        return nextProduct?.dataset || {};
    }

    updateResources() {
        const { addtocart, subtitle, title, url } = this.getNextProduct();
        if (!addtocart) {
            this.querySelector('.js-subtitle').classList.add('d-none');
            this.querySelector('.js-title').classList.add('d-none');
            this.querySelector('.js-next-product').classList.add('d-none');
            this.querySelector('.js-to-cart').classList.remove('d-none');
        } else {
            this.querySelector('.js-next-product').innerText = addtocart;
            this.querySelector('.js-subtitle').innerText = subtitle;
            this.querySelector('.js-subtitle').classList.remove('d-none');
            this.querySelector('.js-title').innerText = title;
            this.querySelector('.js-title').classList.remove('d-none');
            this.querySelector('.js-next-product').href = url;
            this.querySelector('.js-next-product').classList.remove('d-none');
            this.querySelector('.js-to-cart').classList.add('d-none');
        }
    }

    /**
     * @function populateModal
     * @param {Array<string>} productsInJourney - Products in the journey
     */
    toggleProductVisibility(productsInJourney) {
        [...this.querySelectorAll('[data-id]')].forEach((product) => {
            if (productsInJourney.includes(product.getAttribute('data-id'))) {
                product.classList.remove('d-none');
            } else {
                product.classList.add('d-none');
            }
        });
    }
}

if (!window.customElements.get('vz-journey-modal')) {
    window.customElements.define('vz-journey-modal', VZJourneyModal);
}
